import React from 'react'
import { IssuingCardStatus } from './issuingCardStatus'

export const IssuingModifyCardStatus = () => {
  return (
    <IssuingCardStatus />
  )
}
